// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3RC8L","alert":"SettungsInbox_alert__QqSCY"};